import { render } from "./AdditionalInformationReport.vue?vue&type=template&id=5c292139&ts=true"
import script from "./AdditionalInformationReport.vue?vue&type=script&lang=ts"
export * from "./AdditionalInformationReport.vue?vue&type=script&lang=ts"

import "./AdditionalInformationReport.vue?vue&type=style&index=0&id=5c292139&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__